import React from "react";
import { Container } from "reactstrap";
import BodyComponent from "./BodyComponent";

const IndexComponent = () => {
  return (
    <Container>
      <BodyComponent />
    </Container>
  );
};
export default IndexComponent;
